export const batchArray = [
    "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994",
    "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004",
    "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014",
    "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024",
    "2025", "2026", "2027", "2028", "2029", "2030", "2031", "2032", "2033", "2034",
    "2035", "2036", "2037", "2038", "2039", "2040", "2041", "2042", "2043", "2044",
    "2045", "2046", "2047", "2048", "2049", "2050", "Not Applicable"
];

export const countryArray = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo (Congo-Brazzaville)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czechia (Czech Republic)",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini (fmr. \"Swaziland\")",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Holy See",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea (North)",
    "Korea (South)",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (formerly Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia (formerly Macedonia)",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine State",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"
];


export const professionalBackgroundArray = [
  "Corporate/Business Professional",
  "Entrepreneur/Business Owner",
  "Freelancer/Independent Professional",
  "Academics and Researchers",
  "Creative and Performing Arts",
  "Healthcare and Medicine",
  "Legal and Judiciary",
  "Government and Public Service",
  "Science, Technology, Engineering, and Mathematics (STEM)",
  "Social Work and Non-Profit",
  "Hospitality, Tourism, and Events",
  "Sports and Fitness",
  "Retired/Semi-Retired Professional",
  "Homemaker/Caregiver",
  "Student/Learner/Early Career Professional",
  "Not Working Currently/On a Break",
  "Aerospace, Aviation, and Automotive",
  "Others"
];


export const professionalIndustryArray = [
  "Business, Finance, and Consulting",
  "Information Technology and Software",
  "Healthcare and Medicine",
  "Engineering and Manufacturing",
  "Law and Legal Services",
  "Education and Academia",
  "Marketing, Advertising, and Public Relations",
  "Creative Arts and Media",
  "Government and Public Service",
  "Social Work and Non-Profit",
  "Science and Research",
  "Sales and Customer Service",
  "Hospitality and Tourism",
  "Real Estate and Property Management",
  "Agriculture, Forestry, and Environmental Science",
  "Logistics, Supply Chain, and Operations",
  "Human Resources, Organizational Development, and Talent Management",
  "Fashion, Apparel, and Luxury Goods",
  "Food, Nutrition, and Culinary Arts",
  "Aerospace, Aviation, and Automotive",
  "Sports, Fitness, and Wellness",
  "Psychology, Counseling",
  "Telecommunications and Network Infrastructure",
  "New-Age and Emerging Industries",
  "Freelance, Gig Economy, and Remote Work"
];


export const industryExpertiseArray = [
  // Corporate / Finance
  "Corporate Strategy & Leadership",
  "Financial Services (Banking, Investment, Fintech)",
  "Accounting and Auditing",
  "Economists and Actuaries",
  "Consulting (Management, Financial, Strategic)",
  "Human Resources and People Management",

  // Information Technology
  "Software Development & Engineering",
  "Data Science, AI, and Machine Learning",
  "Cybersecurity",
  "IT Infrastructure & Systems Administration",
  "Blockchain and Cryptocurrency",

  // Healthcare & Medicine
  "Clinical Medicine (Doctors, Nurses)",
  "Pharmaceuticals and Biotechnology",
  "Public Health and Epidemiology",
  "Healthcare Administration",
  "Telemedicine and Digital Health",
  "Medical Research",

  // Engineering
  "Mechanical, Civil, and Electrical Engineering",
  "Chemical Engineering",
  "Industrial & Manufacturing Engineering",
  "Quality Assurance and Safety",
  "Robotics and Automation",

  // Legal
  "Corporate Law and Litigation",
  "Compliance and Regulatory Affairs",
  "Intellectual Property and Patent Law",
  "Legal Advisory and Consultancy",
  "Paralegal Services",

  // Education
  "Teaching (K-12, Higher Education)",
  "Research (STEM, Humanities, Social Sciences)",
  "Educational Administration & Policy",
  "Educational Technology (EdTech)",
  "Career and Academic Counseling",

  // Marketing & Media
  "Brand Management and Strategy",
  "Digital Marketing and Social Media",
  "Public Relations and Communications",
  "Content Creation and Influencer Marketing",
  "Market Research and Analytics",

  // Creative Arts
  "Graphic Design, Animation, and Visual Arts",
  "Journalism, Writing, Editing, and Publishing",
  "Music, Film, and Performing Arts",
  "Photography and Videography",
  "New Media (Podcasts, Streaming Content, YouTube)",

  // Government & Public Service
  "Civil Services/Government Administration",
  "Policy Analysis, Research and Governance",
  "International Development/Relations",
  "Defense and Security Services",
  "Regulatory and Administrative Bodies",

  // Non-Profit
  "Non-Profit and NGO Management",
  "Community Development",
  "Healthcare and Wellness",
  "Disaster Relief and Humanitarian Aid",
  "Environmental Conservation",
  "Advocacy and Human Rights",
  "Social Entrepreneurship",

  // Research & Science
  "Life Sciences (Biology, Ecology, Biochemistry, etc)",
  "Physical Sciences (Physics, Chemistry, Astronomy, etc)",
  "Social sciences (Psychology, Sociology, History, etc)",
  "Environmental Science",
  "Laboratory Research",
  "Data Science in Research Applications",
  "Research Roles in Academia and Private Institutions",

  // Sales & Customer
  "Sales (B2B, B2C, Tech Sales)",
  "Account Management",
  "Customer Success and Service",
  "E-commerce Operations & Management",
  "Retail Management",

  // Hospitality
  "Hotel and Resort Management",
  "Travel and Tourism Services",
  "Event Planning and Management",
  "Food and Beverage Management",
  "Guest Relations",

  // Real Estate
  "Real Estate Sales and Brokerage",
  "Property Management",
  "Urban Planning and Development",
  "Architecture and Interior Design",
  "Land and Property Valuation",

  // Agriculture
  "Farming and Agribusiness",
  "Environmental Science and Conservation",
  "Forestry and Wildlife Management",
  "Sustainable Development and Renewable Energy",
  "Food Science and Technology",

  // Logistics
  "Supply Chain Management",
  "Procurement and Vendor Relations",
  "Logistics and Warehousing",
  "Transportation Management",
  "Inventory and Quality Control",

  // HR
  "Talent Acquisition and Recruitment",
  "Organizational Development and Training",
  "Diversity, Equity, and Inclusion (DEI)",
  "Employee Engagement and Retention",
  "Compensation and Benefits",

  // Fashion
  "Fashion Design and Merchandising",
  "Apparel Production and Textile Management",
  "Luxury Brand Management",
  "Jewelry Design and Gemology",
  "Fashion Buying and Retail",

  // Food & Nutrition
  "Dietetics and Nutrition",
  "Culinary Arts and Food Preparation",
  "Food Safety and Quality Assurance",
  "Beverage Industry (Brewing, Distilling, etc.)",
  "Catering and Culinary Management",

  // Aerospace / Aviation / Auto
  "Aerospace Engineering",
  "Aviation Services (Pilots, Air Traffic Control)",
  "Automotive Engineering and Manufacturing",
  "Drone Technology and Applications",
  "Space Exploration and Research",

  // Sports & Wellness
  "Professional Athletics and Coaching",
  "Fitness Training and Personal Coaching",
  "Sports Management and Event Organization",
  "Physical Therapy and Sports Medicine",
  "Wellness and Lifestyle Coaching",

  // Psychology
  "Clinical Psychology and Counseling",
  "Industrial-Organizational Psychology",
  "Behavioral Science and Therapy",
  "Child Development and Family Support",

  // Telecom
  "Telecommunications Engineering",
  "Network Architecture and Cloud Infrastructure",
  "Broadband and Fiber Optics",
  "Satellite Communications",
  "Network Security",

  // Emerging
  "Direct-to-Consumer (D2C) Brands (Beauty, Skincare, Lifestyle)",
  "Startups and Entrepreneurship",
  "Renewable Energy and CleanTech",
  "AI & Automation (including Robotics and AI Ethics)",
  "Esports and Gaming",

  // Freelance
  "Freelance Writing, Design, Consulting, Make-up, Tailoring",
  "Virtual Assistance",
  "Digital Nomads and Remote Work Specialists",
  "Online Tutoring and Virtual Teaching",
  "Others"
];


export const undergraduateDegreeArray = [
  "B.A. (Bachelor of Arts)",
  "B.A. (Bachelor of Arts) Hons",
  "B.F.A. (Bachelor of Fine Arts)",
  "B.Litt. (Bachelor of Literature)",
  "B.Phil. (Bachelor of Philosophy)",
  "B.Mus. (Bachelor of Music)",
  "B.Lib.Sc. (Bachelor of Library Science)",
  "B.S.W. (Bachelor of Social Work)",
  "B.I.R. (Bachelor of International Relations)",

  "B.Sc. (Bachelor of Science)",
  "B.Sc. (IT) (Bachelor of Science in Information Technology)",
  "B.Sc. (Nursing)",
  "B.Tech. (Bachelor of Technology)",
  "B.E. (Bachelor of Engineering)",
  "B.Arch. (Bachelor of Architecture)",
  "B.Env.Sc. (Bachelor of Environmental Science)",
  "B.Math. (Bachelor of Mathematics)",
  "B.Stat. (Bachelor of Statistics)",

  "B.Com. (Bachelor of Commerce)",
  "B.B.A. (Bachelor of Business Administration)",
  "B.M.S. (Bachelor of Management Studies)",
  "B.F.M. (Bachelor of Financial Markets)",
  "B.I.B. (Bachelor of International Business)",

  "MBBS (Bachelor of Medicine and Bachelor of Surgery)",
  "B.D.S. (Bachelor of Dental Surgery)",
  "B.A.M.S. (Bachelor of Ayurvedic Medicine and Surgery)",
  "B.H.M.S. (Bachelor of Homeopathic Medicine and Surgery)",
  "B.N.Y.S. (Bachelor of Naturopathy and Yogic Sciences)",
  "B.Pharm. (Bachelor of Pharmacy)",
  "B.P.T. (Bachelor of Physiotherapy)",
  "B.O.T. (Bachelor of Occupational Therapy)",
  "B.U.M.S. (Bachelor of Unani Medicine and Surgery)",

  "L.L.B. (Bachelor of Laws)",
  "B.A. LL.B. (Integrated Law Degree)",
  "B.Sc. LL.B.",
  "B.Com. LL.B.",

  "B.Ed. (Bachelor of Education)",
  "B.El.Ed. (Bachelor of Elementary Education)",
  "B.P.Ed. (Bachelor of Physical Education)",

  "B.Des. (Bachelor of Design)",
  "B.F.D. (Bachelor of Fashion Design)",
  "B.H.M. (Bachelor of Hotel Management)",
  "B.V.A. (Bachelor of Visual Arts)",
  "B.J.M.C. (Bachelor of Journalism and Mass Communication)",
  "B.M.C. (Bachelor of Media and Communication)",
  "B.A.J. (Bachelor of Arts in Journalism)",
  "B.P.A. (Bachelor of Performing Arts)",

  "B.C.A. (Bachelor of Computer Applications)",
  "B.A.F. (Bachelor of Animation and Film)",
  "B.I.D. (Bachelor of Industrial Design)",
  "B.G.D. (Bachelor of Game Design)",

  "B.Agri.Tech. (Bachelor of Agricultural Technology)",
  "B.F.T. (Bachelor of Fisheries Technology)",
  "B.T.T.M. (Bachelor of Tourism and Travel Management)",

  "B.A. in Cultural Studies",
  "B.A.S. (Bachelor of Actuarial Science)",
  "B.A.R.S. (Bachelor of Arts in Religious Studies)",
  "B.A. (Public Policy)",
  "B.A. (Ethics)",

  "B.Sc (Fashion)",
  "B.Com. (Bachelor of Commerce) Hons",
  "B.Sc. (Bachelor of Science) Hons",
  "B.VSc & AH (Bachelor of Veterinary Science & Animal Husbandry)",

  "B.B.M. (Bachelors of Business Management)",
  "B.Tech. (Bachelor of Technology) Integrated Degree",
  "B.B.A LL.B.",
  "B.A. LL.B.",
  "B.B.A. (Bachelor of Business Administration) Hons",

  "B.A. (Liberal Arts)",
  "B.M.M. (Bachelors of Mass Media)",
  "Diploma (Visual Communication)",

  "Not Applicable",
  "Drop Year",
  "Others"
];

export const postgraduateDegreeArray = [
  "M.A. (Master of Arts)",
  "M.F.A. (Master of Fine Arts)",
  "M.Litt. (Master of Literature)",
  "M.Mus. (Master of Music)",
  "M.Phil. (Master of Philosophy)",
  "M.Sc. (Master of Science)",
  "M.Tech. (Master of Technology)",
  "M.E. (Master of Engineering)",
  "M.Arch. (Master of Architecture)",
  "M.Sc. (IT) (Master of Science in Information Technology)",
  "M.Env.Sc. (Master of Environmental Science)",
  "M.Stat. (Master of Statistics)",
  "M.Math. (Master of Mathematics)",
  "M.Com. (Master of Commerce)",
  "M.B.A. (Master of Business Administration)",
  "M.M.S. (Master of Management Studies)",
  "M.I.B. (Master of International Business)",
  "M.F.M. (Master of Financial Management)",

  "M.D. (Doctor of Medicine)",
  "M.S. (Master of Surgery)",
  "M.Pharm. (Master of Pharmacy)",
  "M.P.T. (Master of Physiotherapy)",
  "M.O.T. (Master of Occupational Therapy)",
  "M.N. (Master of Nursing)",
  "M.H.A. (Master of Hospital Administration)",

  "L.L.M. (Master of Laws)",
  "M.P.A. (Master of Public Administration)",
  "M.P.P. (Master of Public Policy)",
  "M.G.L. (Master of General Laws)",

  "M.Ed. (Master of Education)",
  "M.P.Ed. (Master of Physical Education)",
  "M.A.Ed. (Master of Arts in Education)",
  "M.Phil. (Master of Philosophy)",

  "Ph.D. (Doctor of Philosophy)",
  "Ed.D. (Doctor of Education)",
  "D.Sc. (Doctor of Science)",
  "D.Litt. (Doctor of Literature)",
  "D.Phil. (Doctor of Philosophy)",

  "M.Des. (Master of Design)",
  "M.H.M. (Master of Hotel Management)",
  "M.V.A. (Master of Visual Arts)",
  "M.J.M.C. (Master of Journalism and Mass Communication)",
  "M.A.M.C. (Master of Arts in Media and Communication)",
  "M.A.J. (Master of Arts in Journalism)",
  "M.A.S. (Master of Actuarial Science)",
  "M.P.A. (Master of Performing Arts)",

  "M.C.A. (Master of Computer Applications)",
  "M.I.T. (Master of Information Technology)",
  "M.E.S. (Master of Environmental Science)",
  "M.S.E. (Master of Software Engineering)",

  "M.A.H.R. (Master of Arts in Human Rights)",
  "M.A.I.R. (Master of Arts in International Relations)",
  "M.C.H. (Master of Surgery in Cardiac Surgery)",
  "M.Sc. (Forensic Science)",

  "Executive M.B.A.",
  "M.A. (Cultural Studies)",
  "M.A. (Linguistics)",
  "M.A. (Area Studies) (e.g., East Asian Studies, African Studies)",
  "M.A. (Human Rights)",
  "M.A. (Development Studies)",
  "M.A. (Urban Studies)",
  "M.A. (Gender Studies)",
  "M.A. (Museum Studies)",
  "M.A. (Archival Science)",
  "M.A. (Globalization Studies)",
  "M.A. (Creative Writing)",

  "PG Diploma (PR, Advertising & Digital Marketing)",
  "Chartered Accountantancy (CA)",
  "Integrated Fashion Technology",
  "PG Diploma (Print Journalism)",
  "MBA (Fashion and Visual Merchandise)",
  "M.S. (Fashion Management)",
  "M.B.E. (Masters in Business Economics)",
  "International Masters in Business",
  "PG IDS (Interior Design & Styling)",
  "Diploma (Visual Communication)",
  "Post Graduate Certificate Program (Management and Leadership)",

  "B.A. LL.B.", 
  "Not Applicable",
  "Others"
];
